/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import AppReport from "views/pages/Dashboard/AppReport/Index.js";
import Profile from "views/pages/Dashboard/Profile/Index.js";
import Login from "views/pages/Dashboard/Login/Index";
import ConfirmEmail from "views/pages/Dashboard/ConfirmEmail/Index";
import Register from "views/pages/Dashboard/Register/Index.js";
import EditProfile from "views/pages/Dashboard/EditProfile/Index";
import ResetPassword from "views/pages/Dashboard/ResetPassword/Index";
import ConfirmPassword from "views/pages/Dashboard/ConfirmPassword/Index";
import ResetPasswordSuccess from "views/pages/Dashboard/ResetPasswordSuccess/Index";
import Institutions from "views/pages/Dashboard/Institutions/Index";
import InstitutionFormData from "views/pages/Dashboard/Institutions/FormData";
import Devices from "views/pages/Dashboard/Devices/Index";
import DeviceFormData from "views/pages/Dashboard/Devices/FormData";
import Students from "views/pages/Dashboard/Students/Index";
import StudentFormData from "views/pages/Dashboard/Students/FormData";

import Home from "views/pages/Dashboard/Home/Index.js";
import Tables from "views/examples/Tables.js";
import Maps from "views/examples/Maps/Index.js";
import Icons from "views/examples/Icons.js";
import CredentialTypes from "views/pages/Dashboard/CredentialTypes/Index";
import CredentialTypesFormData from "views/pages/Dashboard/CredentialTypes/FormData";
import Credentials from "views/pages/Dashboard/Credentials/Index";
import CredentialsFormData from "views/pages/Dashboard/Credentials/FormData";
import Apps from "views/pages/Dashboard/Apps/Index";
import AppFormData from "views/pages/Dashboard/Apps/FormData";
import Plans from "views/pages/Dashboard/Plans/Index";
import PlanFormData from "views/pages/Dashboard/Plans/FormData";
import InstallationTypes from "views/pages/Dashboard/InstallationTypes/Index";
import InstallationTypesFormData from "views/pages/Dashboard/InstallationTypes/FormData";
import Coupons from "views/pages/Dashboard/Coupons/Index";
import CouponFormData from "views/pages/Dashboard/Coupons/FormData";
import Payments from "views/pages/Dashboard/Payments/Index";
import PaymentFormData from "views/pages/Dashboard/Payments/FormData";
import Groups from "views/pages/Dashboard/Groups/Index";
import GroupFormData from "views/pages/Dashboard/Groups/FormData";
import Subscriptions from "views/pages/Dashboard/Subscriptions/Index";
import SubscriptionFormData from "views/pages/Dashboard/Subscriptions/FormData";

import Test from "views/pages/Dashboard/Test/Index";

import homeIcon from "assets/img/icons/common/home-icon.svg";
import institutionIcon from "assets/img/icons/common/institution-icon.svg";
import deviceIcon from "assets/img/icons/common/device-icon.svg";
import studentIcon from "assets/img/icons/common/student-icon.svg";
import credentialIcon from "assets/img/icons/common/credential-icon.svg";
import appsIcon from "assets/img/icons/common/app-icon.svg";
import paymentsIcon from "assets/img/icons/common/payment-icon.svg";
import couponsIcon from "assets/img/icons/common/coupon-icon.svg";
import credentialTypeIcon from "assets/img/icons/common/credentialTypes-icon.svg";
import InstallationTypeIcon from "assets/img/icons/common/installationTypes-icon.svg";
import planIcon from "assets/img/icons/common/plan-icon.svg";
import groupsIcon from "assets/img/icons/common/plan-icon.svg";
import secureLocalStorage from "react-secure-storage";

const getUserData = () => {
  try {
    const user = secureLocalStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("Erro ao obter dados do usuário: ", error);
    return null;
  }
};


const hasRouteAccess = (routeKey) => {
  // Rotas públicas sempre acessíveis
  const publicRoutes = [
    "login",
    "register",
    "confirm-email",
    "reset-password",
    "confirm-password",
    "reset-success",
  ];
  if (publicRoutes.includes(routeKey)) return true;

  // Garante que o usuário já foi carregado
  const userData = getUserData();

  if (!userData || !userData?.credential?.type) {
    console.warn("Usuário não carregado, rota bloqueada:", routeKey);
    return false;
  }

  const allowedRoutes = userData.credential.type.allowedRoutes || [];

  // Se estiver vazio, não tem permissão
  if (!allowedRoutes.length) return false;

  // `all` significa acesso total
  if (allowedRoutes.includes("all")) return true;

  return allowedRoutes.includes(routeKey);
};



var routes = [
  /////////////////////////////////////////////////
  //AppReport
  {
    path: "/appreport",
    name: "App Report",
    icon: "ni ni-tv-2 text-primary",
    component: <AppReport />,
    layout: "/admin",
    complement: "",
    sidebarVisible: true,
    api: false,
    routeKey: "appreport"
  },

  /////////////////////////////////////////////////
  //Home
  {
    path: "/index",
    name: "Home",
    icon: homeIcon,
    component: <Home />,
    layout: "/admin",
    complement: "",
    sidebarVisible: false,
    api: true,
    routeKey: "index"
  },
  /////////////////////////////////////////////////
  /////////////////////////////////////////////////
  //Institutions
  {
    path: "/institutions",
    name: "Institutions",
    icon: institutionIcon,
    component: <Institutions />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "institutions"
  },
  {
    path: "/institution/view/:id",
    name: "Institution's Profile",
    icon: "ni ni-building text-yellow",
    component: <InstitutionFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "institutions"
  },
  {
    path: "/institution/create",
    name: "Institution's Profile",
    icon: "ni ni-building text-yellow",
    component: <InstitutionFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "institutions"
  },
  {
    path: "/institution/edit/:id",
    name: "Institution's Profile",
    icon: "ni ni-building text-yellow",
    component: <InstitutionFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "institutions"
  },
  /////////////////////////////////////////////////

  /////////////////////////////////////////////////
  //Credentials
  {
    path: "/credentials",
    name: "Credentials",
    icon: credentialIcon,
    component: <Credentials />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "credentials"
  },
  {
    path: "/credentials/view/:id",
    name: "Credential's Data",
    icon: "ni ni-building text-yellow",
    component: <CredentialsFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "credentials"
  },
  {
    path: "/credentials/create",
    name: "Credential's",
    icon: "ni ni-building text-yellow",
    component: <CredentialsFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "credentials"
  },
  {
    path: "/credentials/edit/:id",
    name: "Credential's Data",
    icon: "ni ni-building text-yellow",
    component: <CredentialsFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "credentials"
  },
  /////////////////////////////////////////////////

  /////////////////////////////////////////////////
  //Credential Type (apenas para Master)
  {
    path: "/credentialTypes",
    name: "Credential Types",
    icon: credentialTypeIcon,
    component: <CredentialTypes />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "credentialTypes"
  },
  {
    path: "/credentialTypes/view/:id",
    name: "Credential Types's Data",
    icon: "ni ni-building text-yellow",
    component: <CredentialTypesFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "credentialTypes"
  },
  {
    path: "/credentialTypes/create",
    name: "Credential Types's",
    icon: "ni ni-building text-yellow",
    component: <CredentialTypesFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "credentialTypes"
  },
  {
    path: "/credentialTypes/edit/:id",
    name: "Credential Types's Data",
    icon: "ni ni-building text-yellow",
    component: <CredentialTypesFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "credentialTypes"
  },
  /////////////////////////////////////////////////

  /////////////////////////////////////////////////
  //Installation Type (apenas para Master)
  {
    path: "/installationTypes",
    name: "Installation Types",
    icon: InstallationTypeIcon,
    component: <InstallationTypes />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "installationTypes"
  },
  {
    path: "/installationTypes/view/:id",
    name: "Installation Types's Data",
    icon: "ni ni-building text-yellow",
    component: <InstallationTypesFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "installationTypes"
  },
  {
    path: "/installationTypes/create",
    name: "Installation Types's",
    icon: "ni ni-building text-yellow",
    component: <InstallationTypesFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "installationTypes"
  },
  {
    path: "/installationTypes/edit/:id",
    name: "Installation Types's Data",
    icon: "ni ni-building text-yellow",
    component: <InstallationTypesFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "installationTypes"
  },
  /////////////////////////////////////////////////

  /////////////////////////////////////////////////
  //Device
  {
    path: "/devices",
    name: "Devices",
    icon: deviceIcon,
    component: <Devices />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "devices"
  },
  {
    path: "/device/view/:id",
    name: "Device's Data",
    icon: "ni ni-building text-yellow",
    component: <DeviceFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "devices"
  },
  {
    path: "/device/create",
    name: "Device's",
    icon: "ni ni-building text-yellow",
    component: <DeviceFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "devices"
  },
  {
    path: "/device/edit/:id",
    name: "Device's Data",
    icon: "ni ni-building text-yellow",
    component: <DeviceFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "devices"
  },
  /////////////////////////////////////////////////

  /////////////////////////////////////////////////
  //Students
  {
    path: "/students",
    name: "Students",
    icon: studentIcon,
    component: <Students />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "students"
  },
  {
    path: "/student/view/:id",
    name: "Student's Data",
    icon: "ni ni-hat-3 text-yellow",
    component: <StudentFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "students"
  },
  {
    path: "/student/create",
    name: "Student's",
    icon: "ni ni-hat-3 text-yellow",
    component: <StudentFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "students"
  },
  {
    path: "/student/edit/:id",
    name: "Student's Data",
    icon: "ni ni-hat-3 text-yellow",
    component: <StudentFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "students"
  },
  /////////////////////////////////////////////////


  /////////////////////////////////////////////////
  //Apps (apenas Master e Owner)
  {
    path: "/apps",
    name: "Apps",
    icon: appsIcon,
    component: <Apps />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "apps"
  },
  {
    path: "/app/view/:id",
    name: "App's Data",
    icon: "ni ni-building text-yellow",
    component: <AppFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "apps"
  },
  {
    path: "/app/create",
    name: "App's",
    icon: "ni ni-building text-yellow",
    component: <AppFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "apps"
  },
  {
    path: "/app/edit/:id",
    name: "App's Data",
    icon: "ni ni-building text-yellow",
    component: <AppFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "apps"
  },
  /////////////////////////////////////////////////

  /////////////////////////////////////////////////
  //Plans (apenas Master e Owner)
  {
    path: "/plans",
    name: "Plans",
    icon: planIcon,
    component: <Plans />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "plans"
  },
  {
    path: "/plan/view/:id",
    name: "Plan's Data",
    icon: "ni ni-building text-yellow",
    component: <PlanFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "plans"
  },
  {
    path: "/plan/create",
    name: "Plan's",
    icon: "ni ni-building text-yellow",
    component: <PlanFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "plans"
  },
  {
    path: "/plan/edit/:id",
    name: "Plan's Data",
    icon: "ni ni-building text-yellow",
    component: <PlanFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "plans"
  },
  /////////////////////////////////////////////////

  /////////////////////////////////////////////////
  //Test
  {
    path: "/test",
    name: "Test",
    icon: "ni ni-building text-yellow",
    component: <Test />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "test"
  },
  /////////////////////////////////////////////////
  /////////////////////////////////////////////////
  //Coupons
  {
    path: "/coupons",
    name: "Coupons",
    icon: couponsIcon,
    component: <Coupons />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "coupons"
  },
  {
    path: "/coupon/view/:id",
    name: "Coupon's Profile",
    icon: "ni ni-building text-yellow",
    component: <CouponFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "coupons"
  },
  {
    path: "/coupon/create",
    name: "Coupon's Profile",
    icon: "ni ni-building text-yellow",
    component: <CouponFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "coupons"
  },
  {
    path: "/coupon/edit/:id",
    name: "Coupon's Profile",
    icon: "ni ni-building text-yellow",
    component: <CouponFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "coupons"
  },
  /////////////////////////////////////////////////
  /////////////////////////////////////////////////
  //Groups
  {
    path: "/groups",
    name: "Groups",
    icon: groupsIcon,
    component: <Groups />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "groups"
  },
  {
    path: "/group/view/:id",
    name: "Group's Profile",
    icon: "ni ni-building text-yellow",
    component: <GroupFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "groups"
  },
  {
    path: "/group/create",
    name: "Group's Profile",
    icon: "ni ni-building text-yellow",
    component: <GroupFormData action="create" />,
    layout: "/admin",
    complement: "Creation",
    sidebarVisible: false,
    api: true,
    routeKey: "groups"
  },
  {
    path: "/group/edit/:id",
    name: "Group's Profile",
    icon: "ni ni-building text-yellow",
    component: <GroupFormData action="edit" />,
    layout: "/admin",
    complement: "Edition",
    sidebarVisible: false,
    api: true,
    routeKey: "groups"
  },
  /////////////////////////////////////////////////
  /////////////////////////////////////////////////
  //Payments
  {
    path: "/payments",
    name: "Payments",
    icon: paymentsIcon,
    component: <Payments />,
    layout: "/admin",
    complement: "Received",
    sidebarVisible: true,
    api: true,
    routeKey: "payments"
  },
  {
    path: "/payment/view/:id",
    name: "Payment's Profile",
    icon: "ni ni-money-coins text-orange",
    component: <PaymentFormData action="view" />,
    layout: "/admin",
    complement: "Received",
    sidebarVisible: false,
    api: true,
    routeKey: "payments"
  },
  /////////////////////////////////////////////////
  /////////////////////////////////////////////////
  //Subscriptions
  {
    path: "/subscriptions",
    name: "Subscriptions",
    icon: "ni ni-money-coins text-orange",
    component: <Subscriptions />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: true,
    api: true,
    routeKey: "subscriptions"
  },
  {
    path: "/subscription/view/:id",
    name: "Subscription's Profile",
    icon: "ni ni-building text-yellow",
    component: <SubscriptionFormData action="view" />,
    layout: "/admin",
    complement: "Settings",
    sidebarVisible: false,
    api: true,
    routeKey: "subscriptions"
  },
  ///////////////////////////////////////////////// 

  //Movido para o topo para ser listado primeiro
  // {
  //   path: "/appreport",
  //   name: "App Report",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: <AppReport />,
  //   layout: "/admin",
  //   complement: "",
  //   sidebarVisible: true,
  //   api: false,
  //   routeKey: "appreport"
  // },
  {
    path: "/icons",
    name: "Icons",
    icon: "ni ni-planet text-blue",
    component: <Icons />,
    layout: "/admin",
    complement: "",
    sidebarVisible: false,
    api: false,
    routeKey: "examples"
  },
  {
    path: "/maps",
    name: "Maps",
    icon: "ni ni-pin-3 text-orange",
    component: <Maps />,
    layout: "/admin",
    complement: "",
    sidebarVisible: false,
    api: false,
    routeKey: "examples"
  },
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    complement: "",
    sidebarVisible: false,
    api: true,
    routeKey: "profile"
  },
  {
    path: "/tables",
    name: "Tables",
    icon: "ni ni-bullet-list-67 text-red",
    component: <Tables />,
    layout: "/admin",
    complement: "",
    sidebarVisible: false,
    api: false,
    routeKey: "examples"
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
    complement: "",
    sidebarVisible: false,
    api: true,
    routeKey: "login"
  },
  {
    path: "/confirm-email/:id",
    name: "Confirm Email",
    icon: "ni ni-check-bold text-green",
    component: <ConfirmEmail />,
    layout: "/auth",
    complement: "",
    sidebarVisible: false,
    api: true,
    routeKey: "confirm-email"
  },
  {
    path: "/edit-profile",
    name: "",
    icon: "ni ni-ruler-pencil text-info",
    component: <EditProfile />,
    layout: "/admin",
    complement: "",
    sidebarVisible: false,
    api: true,
    routeKey: "profile"
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    icon: "ni ni-folder-17 text-pink",
    component: <ResetPassword />,
    layout: "/auth",
    complement: "",
    sidebarVisible: false,
    api: true,
    routeKey: "reset-password"
  },
  {
    path: "/confirm-password/:id",
    name: "Confirm Password",
    icon: "ni ni-folder-17 text-pink",
    component: <ConfirmPassword />,
    layout: "/auth",
    complement: "",
    sidebarVisible: false,
    api: true,
    routeKey: "confirm-password"
  },
  {
    path: "/reset-success",
    name: "Password Reset Confirmed",
    icon: "ni ni-folder-17 text-pink",
    component: <ResetPasswordSuccess />,
    layout: "/auth",
    complement: "",
    sidebarVisible: false,
    api: false,
    routeKey: "reset-success"
  }
];

export const getFilteredRoutes = () => {
  return routes.filter(route => hasRouteAccess(route.routeKey));
};

export default routes;
